
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { Card, Row, Col, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { setDetails, setFilters, setList } from "../SalesRecordSlice";
import { fetchSalesRecord } from "../SalesRecordThunk";

import {
  currentDateStartTime,
  currentDateEndTime,
} from "../../../lib/functions";
import { useDefaultDateRange } from "../../../hooks/useDefaultDateRange";
import SearchListAutoComplete from "../../../components/SearchListAutoComplete";

import {
  fetchEmployees,
  fetchCustomers,
  fetchItems,
  fetchGroups,
  fetchCategories,
  fetchUsers,
  fetchTagGroups,
  fetchTagGroupFields,
  fetchLocations,
  fetchItemSerials,
} from "../../../store/commonThunks/lookups";
import { useLocation, useSearchParams } from "react-router-dom";
import CommonDateRangeFilter from "../../../components/common/filters/CommonDateRangeFilter";

const SalesRecordFilters = ({ messageApi }) => {
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.salesRecord);
  const lookups = useSelector((state) => state.lookups);
  const { pathname } = useLocation();
   const [searchParams] = useSearchParams();

    useEffect(() => {
    const dateFrom = searchParams.get("dateFrom");
    const dateTo = searchParams.get("dateTo");

    if (dateFrom && dateTo) {
      dispatch(setFilters({
 filterType: "All",       // ← must be set
      recordType: "without item",
        fromDate: dateFrom,
        toDate: dateTo,
      }));
    }
  }, []);

  // useEffect(() => {
  //   const path = pathname.split("/")[3];
  //   if (path) {
  //     handleFilterChange("filterType", "Date Wise");
  //     handleFilterChange("toDate", path);
  //     handleFilterChange("fromDate",);
  //     handleReport();
  //   }
  // }, []);

  // useEffect(() => {
  //   const path = pathname.split("/")[3];
  //   if (path) {
  //     handleFilterChange("filterType", "Date Wise");
  //     handleFilterChange("toDate", path);
  //     handleFilterChange("fromDate", );
  //     handleReport();
  //   }
  // }, []);

  useDefaultDateRange(setFilters, filters, "thisMonth"); // set defaults

  useEffect(() => {
    // preload lookups
    dispatch(fetchEmployees());
    dispatch(fetchGroups());
    dispatch(fetchCustomers());
    dispatch(fetchItems());
    dispatch(fetchCategories());
    dispatch(fetchUsers());
    dispatch(fetchTagGroups());
    dispatch(fetchLocations());
  }, [dispatch]);

  useEffect(() => {
    if (filters.filterType && filters.recordType && filters.fromDate && filters.toDate) {
      handleReport();
    }
  }, [filters]);

  const handleFilterChange = (field, value) => {
    if (field === "filterType") {
      const resetFilters = {
        filterType: value,
        customerId: null,
        employeeId: null,
        itemId: null,
        groupId: null,
        categoryId: null,
        userId: null,
        locationId: null,
        tag_groupnameid: null,
        tagFeildNameid: null,
        itemSerial: null,
        recordType:
          ["By Item", "By Tag", "By Group", "By Category"].includes(value)
            ? "without item"
            : "without item", // safe default
      };


      dispatch(setFilters(resetFilters));
      dispatch(setList([]));
      dispatch(setDetails([]));
    } else {
      dispatch(setFilters({ [field]: value }));
      dispatch(setList([]));
      dispatch(setDetails([]));
    }
  };



  const handleReport = async () => {
    if (!filters.filterType) {
      messageApi.warning("Select Filter Type");
      return;
    }
    function getFormattedDateTime(inputDate) {
        if (!inputDate) return null;
      const date = inputDate;
      return date.slice(0, 19).replace("T", " "); // Converts to 'YYYY-MM-DD HH:MM:SS'
    }
    const payload = {
      selectedFilterType: filters.filterType,
      selectedRecordType: filters.recordType,
      filters: {
        ...filters,
        fromDate: getFormattedDateTime(filters.fromDate),
        toDate: getFormattedDateTime(filters.toDate),
      },
    };

    const res = await dispatch(fetchSalesRecord(payload));
    if (res.meta?.requestStatus === "fulfilled") {
      messageApi.success("Report loaded ✅");
    } else {
      messageApi.error("Failed to fetch records ❌");
    }
  };

  // dynamic extra fields (kept your mapping)
  // const renderExtraField = () => {
  //   switch (filters.filterType) {
  //     case "By Employee":
  //       return (
  //         <Col xs={24} sm={12} md={8} xl={5}>
  //           <label>Search Employee</label>
  //           <SearchListAutoComplete
  //             entityType="employee"
  //             optionsList={(lookups.employees || []).map((e) => ({ sale_id: e.employee_id, display_text: e.employee_name }))}
  //             onSelect={(obj) => handleFilterChange("employeeId", obj?.sale_id)}
  //             placeholder="Search Employee"
  //             showAddNew={false}
  //           />
  //         </Col>
  //       );
  //     case "By Customer":
  //       return (
  //         <Col xs={24} sm={12} md={8} xl={5}>
  //           <label>Search Customer</label>
  //           <SearchListAutoComplete
  //             entityType="customer"
  //             optionsList={(lookups.customers || []).map((e) => ({ sale_id: e.acc_id, display_text: e.acc_name }))}
  //             onSelect={(obj) => handleFilterChange("customerId", obj?.sale_id)}
  //             placeholder="Customer"
  //             showAddNew={false}
  //           />
  //         </Col>
  //       );
  //     case "By Item":
  //       return (
  //         <Col xs={24} sm={12} md={8} xl={5}>
  //           <label>Search Item</label>
  //           <SearchListAutoComplete
  //             entityType="item"
  //             optionsList={(lookups.items || []).map((e) => ({ sale_id: e.item_id, display_text: e.item_name }))}
  //             onSelect={(obj) => handleFilterChange("itemId", obj?.sale_id)}
  //             placeholder="Item"
  //             showAddNew={false}
  //           />
  //         </Col>
  //       );
  //     case "By Group":
  //       return (
  //         <Col xs={24} sm={12} md={8} xl={5}>
  //           <label>Search Group</label>
  //           <SearchListAutoComplete
  //             entityType="group"
  //             optionsList={(lookups.groups || []).map((e) => ({ sale_id: e.group_id, display_text: e.group_name }))}
  //             onSelect={(obj) => handleFilterChange("groupId", obj?.sale_id)}
  //             placeholder="Group"
  //             showAddNew={false}
  //           />
  //         </Col>
  //       );
  //     case "By Category":
  //       return (
  //         <Col xs={24} sm={12} md={8} xl={5}>
  //           <label>Search Category</label>
  //           <SearchListAutoComplete
  //             entityType="category"
  //             optionsList={(lookups.categories || []).map((e) => ({ sale_id: e.category_id, display_text: e.category_name }))}
  //             onSelect={(obj) => {
  //               handleFilterChange("categoryId", obj?.sale_id)
  //               console.log(obj, "obj");
  //             }}
  //             placeholder="Category"
  //             showAddNew={false}
  //             allowClear={true}
  //           />
  //         </Col>
  //       );
  //     case "By User":
  //       return (
  //         <Col xs={24} sm={12} md={8} xl={5}>
  //           <label>Search User</label>
  //           <SearchListAutoComplete
  //             entityType="user"
  //             optionsList={(lookups.users || []).map((e) => ({ sale_id: e.id, display_text: e.full_name }))}
  //             onSelect={(obj) => handleFilterChange("userId", obj?.sale_id)}
  //             placeholder="User"
  //             showAddNew={false}
  //           />
  //         </Col>
  //       );
  //     case "By Tag":
  //       return (
  //         <>
  //           <Col xs={24} sm={12} md={8} xl={5}>
  //             <label>Tag Group</label>
  //             <SearchListAutoComplete
  //               optionsList={(lookups.tagGroups || []).map((tg) => ({ sale_id: tg.id, display_text: tg.tag_groupname }))}
  //               onSelect={(obj) => {
  //                 handleFilterChange("tag_groupnameid", obj?.sale_id);
  //                 if (obj?.sale_id) dispatch(fetchTagGroupFields(obj.sale_id));
  //               }}
  //               placeholder="Tag Group"
  //               showAddNew={false}
  //             />
  //           </Col>
  //           <Col xs={24} sm={12} md={8} xl={5}>
  //             <label>Tag Field</label>
  //             <SearchListAutoComplete
  //               optionsList={(lookups.tagFields || []).map((tf) => ({ sale_id: tf.id, display_text: tf.display_text || tf.combinedField }))}
  //               onSelect={(obj) => handleFilterChange("tagFeildNameid", obj?.sale_id)}
  //               placeholder="Tag Field"
  //               showAddNew={false}
  //             />
  //           </Col>
  //         </>
  //       );
  //     case "By Location":
  //       return (
  //         <Col xs={24} sm={12} md={8} xl={5}>
  //           <label>Search Location</label>
  //           <SearchListAutoComplete
  //             optionsList={(lookups.locations || []).map((loc) => ({ sale_id: loc.location_id, display_text: loc.location_name }))}
  //             onSelect={(obj) => handleFilterChange("locationId", obj?.sale_id)}
  //             placeholder="Location"
  //             showAddNew={false}
  //           />
  //         </Col>
  //       );
  //     default:
  //       return null;
  //   }
  // };

  const renderExtraField = () => {
    // Add this helper function inside renderExtraField or in the component
    const handleFilterClear = (field) => {
   
      dispatch(setFilters({ [field]: null }));
      dispatch(setList([]));
      dispatch(setDetails([]));
    };

    switch (filters.filterType) {
      case "By Employee":
        return (
          <Col xs={24} sm={12} md={8} xl={5}>
            <label>Search Employee</label>
            <SearchListAutoComplete
              entityType="employee"
              optionsList={(lookups.employees || []).map((e) => ({ sale_id: e.employee_id, display_text: e.employee_name }))}
              onSelect={(obj) => handleFilterChange("employeeId", obj?.sale_id)}
              onClear={() => handleFilterClear("employeeId")}
              placeholder="Search Employee"
              showAddNew={false}
              allowClear={true}
            />
          </Col>
        );
      case "By Customer":
        return (
          <Col xs={24} sm={12} md={8} xl={5}>
            <label>Search Customer</label>
            <SearchListAutoComplete
              entityType="customer"
              optionsList={(lookups.customers || []).map((e) => ({ sale_id: e.acc_id, display_text: e.acc_name }))}
              onSelect={(obj) => handleFilterChange("customerId", obj?.sale_id)}
              onClear={() => handleFilterClear("customerId")}
              placeholder="Customer"
              showAddNew={false}
              allowClear={true}
            />
          </Col>
        );
      case "By Item":
        return (
          <Col xs={24} sm={12} md={8} xl={5}>
            <label>Search Item</label>
            <SearchListAutoComplete
              entityType="item"
              optionsList={(lookups.items || []).map((e) => ({ sale_id: e.item_id, display_text: e.item_name }))}
              onSelect={(obj) => handleFilterChange("itemId", obj?.sale_id)}
              onClear={() => handleFilterClear("itemId")}
              placeholder="Item"
              showAddNew={false}
              allowClear={true}
            />
          </Col>
        );
      case "By Group":
        return (
          <Col xs={24} sm={12} md={8} xl={5}>
            <label>Search Group</label>
            <SearchListAutoComplete
              entityType="group"
              optionsList={(lookups.groups || []).map((e) => ({ sale_id: e.group_id, display_text: e.group_name }))}
              onSelect={(obj) => handleFilterChange("groupId", obj?.sale_id)}
              onClear={() => handleFilterClear("groupId")}
              placeholder="Group"
              showAddNew={false}
              allowClear={true}
            />
          </Col>
        );
      case "By Category":
        return (
          <Col xs={24} sm={12} md={8} xl={5}>
            <label>Search Category</label>
            <SearchListAutoComplete
              entityType="category"
              optionsList={(lookups.categories || []).map((e) => ({ sale_id: e.category_id, display_text: e.category_name }))}
              onSelect={(obj) => {
                handleFilterChange("categoryId", obj?.sale_id)
                console.log(obj, "obj");
              }}
              onClear={() => handleFilterClear("categoryId")}
              placeholder="Category"
              showAddNew={false}
              allowClear={true}
            />
          </Col>
        );
      case "By User":
        return (
          <Col xs={24} sm={12} md={8} xl={5}>
            <label>Search User</label>
            <SearchListAutoComplete
              entityType="user"
              optionsList={(lookups.users || []).map((e) => ({ sale_id: e.id, display_text: e.full_name }))}
              onSelect={(obj) => handleFilterChange("userId", obj?.sale_id)}
              onClear={() => handleFilterClear("userId")}
              placeholder="User"
              showAddNew={false}
              allowClear={true}
            />
          </Col>
        );
      case "By Tag":
        return (
          <>
            <Col xs={24} sm={12} md={8} xl={5}>
              <label>Tag Group</label>
              <SearchListAutoComplete
                optionsList={(lookups.tagGroups || []).map((tg) => ({ sale_id: tg.id, display_text: tg.tag_groupname }))}
                onSelect={(obj) => {
                  handleFilterChange("tag_groupnameid", obj?.sale_id);
                  if (obj?.sale_id) dispatch(fetchTagGroupFields(obj.sale_id));
                }}
                onClear={() => {
                  handleFilterClear("tag_groupnameid");
                  handleFilterClear("tagFeildNameid"); // Clear dependent field too
                }}
                placeholder="Tag Group"
                showAddNew={false}
                allowClear={true}
              />
            </Col>
            <Col xs={24} sm={12} md={8} xl={5}>
              <label>Tag Field</label>
              <SearchListAutoComplete
                optionsList={(lookups.tagFields || []).map((tf) => ({ sale_id: tf.id, display_text: tf.display_text || tf.combinedField }))}
                onSelect={(obj) => handleFilterChange("tagFeildNameid", obj?.sale_id)}
                onClear={() => handleFilterClear("tagFeildNameid")}
                placeholder="Tag Field"
                showAddNew={false}
                allowClear={true}
              />
            </Col>
          </>
        );
      case "By Location":
        return (
          <Col xs={24} sm={12} md={8} xl={5}>
            <label>Search Location</label>
            <SearchListAutoComplete
              key={filters?.filterType}
              optionsList={(lookups.locations || []).map((loc) => ({ sale_id: loc.location_id, display_text: loc.location_name }))}
              onSelect={(obj) => handleFilterChange("locationId", obj?.sale_id)}
              onClear={() => handleFilterClear("locationId")}
              placeholder="Location"
              showAddNew={false}
              allowClear={true}
            />
          </Col>
        );
      default:
        return null;
    }
  };

  return (
    <Card className="product-replace-filters mb-4 shadow-md rounded-xl">
      <Row gutter={[16, 16]} wrap style={{ alignItems: "center" }}>
        <Col xs={24} sm={12} md={8} lg={6} xl={5} xxl={4}>
          <label>Filter Type</label>
          <SearchListAutoComplete
            optionsList={[
              { sale_id: "All", display_text: "All" },
              { sale_id: "By Customer", display_text: "By Customer" },
              { sale_id: "By Employee", display_text: "By Employee" },
              { sale_id: "By Item", display_text: "By Item" },
              { sale_id: "By Tag", display_text: "By Tag" },
              { sale_id: "By Group", display_text: "By Group" },
              { sale_id: "By Category", display_text: "By Category" },
              { sale_id: "By Location", display_text: "By Location" },
              { sale_id: "By User", display_text: "By User" },
            ]}
            value={{ value: filters.filterType, label: filters.filterType }}
            onSelect={(obj) => handleFilterChange("filterType", obj?.sale_id)}
            placeholder="Filter Type"
            showAddNew={false}
          />
        </Col>

        {renderExtraField()}

        {!["By Item", "By Tag", "By Group", "By Category", "By User", "By Location"].includes(filters.filterType) && (
          <Col xs={24} sm={12} md={8} lg={6} xl={5} xxl={4}>
            <label>Record Type</label>
            <SearchListAutoComplete
              optionsList={[
                { sale_id: "with item", display_text: "With Item" },
                { sale_id: "without item", display_text: "Without Item" },
              ]}
              value={{ value: filters.recordType, label: filters.recordType === "with item" ? "With Item" : "Without Item" }}
              onSelect={(obj) => handleFilterChange("recordType", obj?.sale_id)}
              placeholder="Record Type"
              showAddNew={false}
            />
          </Col>
        )}

        <CommonDateRangeFilter
          filters={filters}
          onChange={(fromDate, toDate) => {
            handleFilterChange("fromDate", fromDate);
            handleFilterChange("toDate", toDate);
          }}
        />

        <Col
          xs={24} sm={12} md={9} xl={3}
          style={{ paddingTop: "1.4rem" }}>
          <Button type="primary" icon={<SearchOutlined />} onClick={handleReport} block>
            Submit
          </Button>
        </Col>
      </Row>
      <style>{`
      .product-replace-filters {
        overflow: visible !important;
      }

    @media (min-width: 768px) and (max-width: 1024px) {
      .product-replace-filters .ant-row .ant-col {
        flex: 0 0 50% !important;
        max-width: 50% !important;
      }
    }
  `}</style>
    </Card>
  );
};

export default SalesRecordFilters;
